import { router } from "..";
import { getFenceAlarm } from "../api/fencealarms_{imei}";
import { prices } from "../billing/prices";
import { deviceCard, formatSubscriptionStatus } from "../device/device_card";
import { relativeTimeString, t } from "../locale";
import { addNotificationListener } from "../mobile";
import { state } from "../state";
import { keyValueParagraph } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { getFencealarmWarnings } from "./fa_warnings";

/**
 * @param {Fencealarm} fa
 */
async function fencealarmCard(fa) {
	addNotificationListener("fencealarm", fa.Imei, () => {
		getFenceAlarm(fa.Imei).then((fa) => {
			state.fencealarms[fa.Imei] = fa;
		});
	});

	return deviceCard({
		deviceName: fa.Metadata.Name,
		deviceType: "fencealarm",
		productName: "FenceAlarm",
		warnings: getFencealarmWarnings(fa),
		lines: [
			keyValueParagraph(t.device.card.statusLabel),
			keyValueParagraph(
				`- ${t.voltage}`,
				`${fa.LastReport.Data.Voltage} V`,
			),
			keyValueParagraph(
				`- ${t.fencealarm.alarmLevelLabel}`,
				`${fa.Config.AlarmLevel} V`,
			),
			keyValueParagraph(
				`- ${t.fencealarm.card.batteryLevelLabel}`,
				`${fa.LastReport.Data.Battery}%`,
			),
			keyValueParagraph(
				`- ${t.signalStrength}`,
				`${fa.LastReport.Data.Rssi}%`,
			),
			keyValueParagraph(
				`- ${t.lastActive}`,
				relativeTimeString(fa.LastReport.Timestamp),
			),
			keyValueParagraph(t.device.subscriptionLabel),
			keyValueParagraph(
				`- ${t.device.card.planLabel}`,
				await formatSubscriptionPlan(fa),
			),
			keyValueParagraph(...formatSubscriptionStatus(fa.Subscription)),
		],
		buttons: [
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "monitoring",
					onClick: () => router.jump(`/fencealarm/${fa.Imei}/logs`),
				}),
			),
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "settings",
					onClick: () => router.jump(`/fencealarm/${fa.Imei}`),
				}),
			),
		],
	});
}

/**
 * @param {Fencealarm} fa
 */
async function formatSubscriptionPlan(fa) {
	if (fa.Subscription.Trialing) return t.trial;

	const { FencealarmMonth, FencealarmYear } = await prices;

	switch (fa.Subscription.PriceIds.Current) {
		case FencealarmMonth.Id:
			return t.monthly;
		case FencealarmYear.Id:
			return t.yearly;
	}

	const expiryTime = new Date(fa.Subscription.ExpiresAt);
	if (Date.now() < expiryTime.getTime()) return "";

	return t.none;
}

export { fencealarmCard };
